import React from "react";

const Spinner = () => {
  return (
    <img
      src="./template/vendor/lightbox2/src/images/loading.gif"
      alt="Loading..."
    />
  );
};

export default Spinner;
